import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFiltersActions } from '../../constants/actionTypes/filters';
import { EDealType, EOfferType, ESortBy } from '../../repositories/agent-catalog-search/v1/get-realtors';

export const setDealTypeRealtors = actionGenerator<EFiltersActions.SET_DEAL_TYPE_REALTORS, EDealType | undefined>(
  EFiltersActions.SET_DEAL_TYPE_REALTORS,
);
export const setDealTypeAgencies = actionGenerator<EFiltersActions.SET_DEAL_TYPE_AGENCIES, EDealType | undefined>(
  EFiltersActions.SET_DEAL_TYPE_AGENCIES,
);
export const setOfferTypeRealtors = actionGenerator<EFiltersActions.SET_OFFER_TYPE_REALTORS, EOfferType[] | undefined>(
  EFiltersActions.SET_OFFER_TYPE_REALTORS,
);
export const setOfferTypeAgencies = actionGenerator<EFiltersActions.SET_OFFER_TYPE_AGENCIES, EOfferType[] | undefined>(
  EFiltersActions.SET_OFFER_TYPE_AGENCIES,
);
export const setSortByRealtors = actionGenerator<EFiltersActions.SET_SORT_BY_REALTORS, ESortBy | undefined>(
  EFiltersActions.SET_SORT_BY_REALTORS,
);
export const setSortByAgencies = actionGenerator<EFiltersActions.SET_SORT_BY_AGENCIES, ESortBy | undefined>(
  EFiltersActions.SET_SORT_BY_AGENCIES,
);
export const setSearchTextRealtors = actionGenerator<EFiltersActions.SET_SEARCH_TEXT_REALTORS, string | undefined>(
  EFiltersActions.SET_SEARCH_TEXT_REALTORS,
);
export const setSearchTextAgencies = actionGenerator<EFiltersActions.SET_SEARCH_TEXT_AGENCIES, string | undefined>(
  EFiltersActions.SET_SEARCH_TEXT_AGENCIES,
);

export type TSetDealTypeRealtorsAction = ReturnType<typeof setDealTypeRealtors>;
export type TSetDealTypeAgenciesAction = ReturnType<typeof setDealTypeAgencies>;
export type TSetOfferTypeRealtorsAction = ReturnType<typeof setOfferTypeRealtors>;
export type TSetOfferTypeAgenciesAction = ReturnType<typeof setOfferTypeAgencies>;
export type TSetSortByRealtorsAction = ReturnType<typeof setSortByRealtors>;
export type TSetSortByAgenciesAction = ReturnType<typeof setSortByAgencies>;
export type TSetSearchTextRealtorsAction = ReturnType<typeof setSearchTextRealtors>;
export type TSetSearchTextAgenciesAction = ReturnType<typeof setSearchTextAgencies>;

export type TFiltersActions =
  | TSetDealTypeRealtorsAction
  | TSetDealTypeAgenciesAction
  | TSetOfferTypeRealtorsAction
  | TSetOfferTypeAgenciesAction
  | TSetSortByRealtorsAction
  | TSetSortByAgenciesAction
  | TSetSortByAgenciesAction
  | TSetSearchTextRealtorsAction
  | TSetSearchTextAgenciesAction;
